import { getMainElement, hideInterior, showInterior } from "./utils";

function initSwitcher() {
  const mainEl = getMainElement();

  if (!mainEl) {
    return;
  }

  // get all radio inputs
  const radioInputs = mainEl.querySelectorAll("input[name=view]");

  radioInputs.forEach((radio) => {
    // change event.
    radio.addEventListener("change", function () {
      if (this.checked) {
        const selectedValue = this.value;
        if ("interior" === selectedValue) {
          showInterior();
        } else {
          hideInterior();
        }
      }
    });
  });
}

export default initSwitcher;
